import { type FC } from 'react';

import { getImageFromMapObj } from '@/assets/img/imageMap';
import { getImage } from '@/common/lib/images';
import { toShortNumFormat } from '@/common/lib/toShortNumFormat';
import { StringSmall } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';

interface LevelUpRewardItemProps {
  itemName: string;
  amount: number;
  label: string;
}

export const LevelUpRewardItem: FC<LevelUpRewardItemProps> = ({
  itemName,
  amount,
  label,
}) => {
  const walletOrTicketImage = getImageFromMapObj(itemName);
  const gameItemImage = getImage({ name: itemName, field: 'icon' });

  return (
    <div className="w-1/3 flex flex-col py-1 items-center gap-1 px-2">
      <div className="size-[4.5rem] flex items-center justify-center">
        <Picture
          img={walletOrTicketImage.png || gameItemImage?.img}
          webp={walletOrTicketImage.webp || gameItemImage?.webp}
          className="size-[80%]"
          alt={itemName}
        />
      </div>
      <div className="text-2xl leading-none font-extrabold">
        {toShortNumFormat(amount)}
      </div>
      <StringSmall weight="medium" className="text-white/40">
        {label}
      </StringSmall>
    </div>
  );
};
